export function initTimezones(timezoneSelect, expertState, onChangeCallback) {
    const timezones = [
        { value: 'Pacific/Pago_Pago', label: 'UTC-11:00 - American Samoa' },
        { value: 'Pacific/Niue', label: 'UTC-11:00 - Niue' },
        { value: 'Pacific/Honolulu', label: 'UTC-10:00 - Hawaii' },
        { value: 'Pacific/Tahiti', label: 'UTC-10:00 - Tahiti' },
        { value: 'Pacific/Marquesas', label: 'UTC-09:30 - Marquesas Islands' },
        { value: 'America/Anchorage', label: 'UTC-09:00 - Alaska' },
        { value: 'Pacific/Gambier', label: 'UTC-09:00 - Gambier Islands' },
        { value: 'America/Los_Angeles', label: 'UTC-08:00 - California' },
        { value: 'America/Vancouver', label: 'UTC-08:00 - British Columbia' },
        { value: 'America/Tijuana', label: 'UTC-08:00 - Baja California' },
        { value: 'America/Phoenix', label: 'UTC-07:00 - Arizona' },
        { value: 'America/Denver', label: 'UTC-07:00 - Denver' },
        { value: 'America/Edmonton', label: 'UTC-07:00 - Alberta' },
        { value: 'America/Chicago', label: 'UTC-06:00 - Chicago' },
        { value: 'America/Mexico_City', label: 'UTC-06:00 - Mexico City' },
        { value: 'America/Costa_Rica', label: 'UTC-06:00 - Costa Rica' },
        { value: 'America/Winnipeg', label: 'UTC-06:00 - Manitoba' },
        { value: 'America/New_York', label: 'UTC-05:00 - New York' },
        { value: 'America/Toronto', label: 'UTC-05:00 - Toronto' },
        { value: 'America/Bogota', label: 'UTC-05:00 - Colombia' },
        { value: 'America/Lima', label: 'UTC-05:00 - Peru' },
        { value: 'America/Panama', label: 'UTC-05:00 - Panama' },
        { value: 'America/Caracas', label: 'UTC-04:00 - Venezuela' },
        { value: 'America/Barbados', label: 'UTC-04:00 - Barbados' },
        { value: 'America/Puerto_Rico', label: 'UTC-04:00 - Puerto Rico' },
        { value: 'America/Halifax', label: 'UTC-04:00 - Atlantic Time' },
        { value: 'America/St_Johns', label: 'UTC-03:30 - Newfoundland' },
        { value: 'America/Argentina/Buenos_Aires', label: 'UTC-03:00 - Argentina' },
        { value: 'America/Montevideo', label: 'UTC-03:00 - Uruguay' },
        { value: 'America/Sao_Paulo', label: 'UTC-03:00 - Brazil (São Paulo)' },
        { value: 'America/Santiago', label: 'UTC-03:00 - Chile' },
        { value: 'Atlantic/South_Georgia', label: 'UTC-02:00 - South Georgia' },
        { value: 'America/Noronha', label: 'UTC-02:00 - Fernando de Noronha' },
        { value: 'Atlantic/Azores', label: 'UTC-01:00 - Azores' },
        { value: 'Atlantic/Cape_Verde', label: 'UTC-01:00 - Cape Verde' },
        { value: 'Europe/London', label: 'UTC+00:00 - UK' },
        { value: 'Atlantic/Reykjavik', label: 'UTC+00:00 - Iceland' },
        { value: 'Africa/Accra', label: 'UTC+00:00 - Ghana' },
        { value: 'Europe/Dublin', label: 'UTC+00:00 - Ireland' },
        { value: 'Europe/Lisbon', label: 'UTC+00:00 - Portugal' },
        { value: 'Africa/Casablanca', label: 'UTC+00:00 - Morocco' },
        { value: 'Europe/Paris', label: 'UTC+01:00 - France' },
        { value: 'Europe/Berlin', label: 'UTC+01:00 - Germany' },
        { value: 'Europe/Madrid', label: 'UTC+01:00 - Spain' },
        { value: 'Africa/Lagos', label: 'UTC+01:00 - Nigeria' },
        { value: 'Europe/Amsterdam', label: 'UTC+01:00 - Netherlands' },
        { value: 'Europe/Rome', label: 'UTC+01:00 - Italy' },
        { value: 'Europe/Brussels', label: 'UTC+01:00 - Belgium' },
        { value: 'Europe/Warsaw', label: 'UTC+01:00 - Poland' },
        { value: 'Africa/Johannesburg', label: 'UTC+02:00 - South Africa' },
        { value: 'Africa/Cairo', label: 'UTC+02:00 - Egypt' },
        { value: 'Europe/Athens', label: 'UTC+02:00 - Greece' },
        { value: 'Europe/Helsinki', label: 'UTC+02:00 - Finland' },
        { value: 'Europe/Bucharest', label: 'UTC+02:00 - Romania' },
        { value: 'Europe/Kiev', label: 'UTC+02:00 - Ukraine' },
        { value: 'Asia/Jerusalem', label: 'UTC+02:00 - Israel' },
        { value: 'Asia/Amman', label: 'UTC+02:00 - Jordan' },
        { value: 'Asia/Riyadh', label: 'UTC+03:00 - Saudi Arabia' },
        { value: 'Africa/Nairobi', label: 'UTC+03:00 - Kenya' },
        { value: 'Europe/Moscow', label: 'UTC+03:00 - Moscow' },
        { value: 'Asia/Baghdad', label: 'UTC+03:00 - Iraq' },
        { value: 'Asia/Kuwait', label: 'UTC+03:00 - Kuwait' },
        { value: 'Europe/Istanbul', label: 'UTC+03:00 - Turkey' },
        { value: 'Asia/Tehran', label: 'UTC+03:30 - Iran' },
        { value: 'Asia/Dubai', label: 'UTC+04:00 - UAE' },
        { value: 'Asia/Yerevan', label: 'UTC+04:00 - Armenia' },
        { value: 'Asia/Baku', label: 'UTC+04:00 - Azerbaijan' },
        { value: 'Asia/Tbilisi', label: 'UTC+04:00 - Georgia' },
        { value: 'Asia/Muscat', label: 'UTC+04:00 - Oman' },
        { value: 'Asia/Kabul', label: 'UTC+04:30 - Afghanistan' },
        { value: 'Asia/Karachi', label: 'UTC+05:00 - Pakistan' },
        { value: 'Asia/Tashkent', label: 'UTC+05:00 - Uzbekistan' },
        { value: 'Asia/Ashgabat', label: 'UTC+05:00 - Turkmenistan' },
        { value: 'Asia/Calcutta', label: 'UTC+05:30 - India' },
        { value: 'Asia/Colombo', label: 'UTC+05:30 - Sri Lanka' },
        { value: 'Asia/Kathmandu', label: 'UTC+05:45 - Nepal' },
        { value: 'Asia/Dhaka', label: 'UTC+06:00 - Bangladesh' },
        { value: 'Asia/Thimphu', label: 'UTC+06:00 - Bhutan' },
        { value: 'Asia/Almaty', label: 'UTC+06:00 - Kazakhstan' },
        { value: 'Asia/Yangon', label: 'UTC+06:30 - Myanmar' },
        { value: 'Asia/Cocos', label: 'UTC+06:30 - Cocos Islands' },
        { value: 'Asia/Bangkok', label: 'UTC+07:00 - Thailand' },
        { value: 'Asia/Ho_Chi_Minh', label: 'UTC+07:00 - Vietnam' },
        { value: 'Asia/Jakarta', label: 'UTC+07:00 - Indonesia (Jakarta)' },
        { value: 'Asia/Hanoi', label: 'UTC+07:00 - Hanoi' },
        { value: 'Asia/Shanghai', label: 'UTC+08:00 - China' },
        { value: 'Asia/Singapore', label: 'UTC+08:00 - Singapore' },
        { value: 'Asia/Hong_Kong', label: 'UTC+08:00 - Hong Kong' },
        { value: 'Asia/Kuala_Lumpur', label: 'UTC+08:00 - Malaysia' },
        { value: 'Australia/Perth', label: 'UTC+08:00 - Western Australia' },
        { value: 'Asia/Taipei', label: 'UTC+08:00 - Taiwan' },
        { value: 'Asia/Manila', label: 'UTC+08:00 - Philippines' },
        { value: 'Australia/Eucla', label: 'UTC+08:45 - Eucla' },
        { value: 'Asia/Tokyo', label: 'UTC+09:00 - Japan' },
        { value: 'Asia/Seoul', label: 'UTC+09:00 - South Korea' },
        { value: 'Asia/Pyongyang', label: 'UTC+09:00 - North Korea' },
        { value: 'Australia/Darwin', label: 'UTC+09:30 - Northern Territory' },
        { value: 'Australia/Adelaide', label: 'UTC+09:30 - South Australia' },
        { value: 'Pacific/Port_Moresby', label: 'UTC+10:00 - Papua New Guinea' },
        { value: 'Australia/Brisbane', label: 'UTC+10:00 - Queensland' },
        { value: 'Australia/Sydney', label: 'UTC+10:00 - Sydney' },
        { value: 'Australia/Melbourne', label: 'UTC+10:00 - Melbourne' },
        { value: 'Australia/Hobart', label: 'UTC+10:00 - Tasmania' },
        { value: 'Australia/Lord_Howe', label: 'UTC+10:30 - Lord Howe Island' },
        { value: 'Pacific/Guadalcanal', label: 'UTC+11:00 - Solomon Islands' },
        { value: 'Pacific/Noumea', label: 'UTC+11:00 - New Caledonia' },
        { value: 'Pacific/Norfolk', label: 'UTC+11:00 - Norfolk Island' },
        { value: 'Pacific/Fiji', label: 'UTC+12:00 - Fiji' },
        { value: 'Pacific/Auckland', label: 'UTC+12:00 - New Zealand' },
        { value: 'Pacific/Chatham', label: 'UTC+12:45 - Chatham Islands' },
        { value: 'Pacific/Tongatapu', label: 'UTC+13:00 - Tonga' },
        { value: 'Pacific/Apia', label: 'UTC+13:00 - Samoa' },
        { value: 'Pacific/Kiritimati', label: 'UTC+14:00 - Kiribati (Line Islands)' }
    ];
    const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let selectedTimezone = timezones.find(tz => tz.value === userTz) ||
        timezones.find(tz => tz.value.toLowerCase() === userTz.toLowerCase());
    if (!selectedTimezone) {
        const alternateNames = { 'Asia/Calcutta': 'Asia/Kolkata', 'Asia/Kolkata': 'Asia/Calcutta' };
        const alternateName = alternateNames[userTz];
        if (alternateName)
            selectedTimezone = timezones.find(tz => tz.value === alternateName);
    }
    if (!selectedTimezone) {
        const userRegion = userTz.split('/')[0];
        const userCity = userTz.split('/')[1];
        if (userCity)
            selectedTimezone = timezones.find(tz => tz.value.toLowerCase().includes(userCity.toLowerCase()));
        if (!selectedTimezone)
            selectedTimezone = timezones.find(tz => tz.value.startsWith(userRegion));
    }
    timezoneSelect.innerHTML = timezones.map(tz => {
        return `<option value="${tz.value}" data-label="${tz.label}">${tz.label}</option>`;
    }).join('');
    if (selectedTimezone) {
        timezoneSelect.value = selectedTimezone.value;
        expertState.timezone = selectedTimezone.value;
    }
    else if (timezones.length > 0) {
        timezoneSelect.value = timezones[0].value;
        expertState.timezone = timezones[0].value;
    }
    const updateSelectedDisplay = () => {
        var _a;
        const selectedOption = timezoneSelect.options[timezoneSelect.selectedIndex];
        if (selectedOption) {
            const fullLabel = selectedOption.getAttribute('data-label');
            const locationName = fullLabel.split(' - ')[1] || fullLabel;
            selectedOption.textContent = `${locationName} ${((_a = window.cgBookACallI18n) === null || _a === void 0 ? void 0 : _a.information) || 'Information'}`;
        }
    };
    const restoreFullLabels = () => {
        Array.from(timezoneSelect.options).forEach(option => {
            const fullLabel = option.getAttribute('data-label');
            if (fullLabel)
                option.textContent = fullLabel;
        });
    };
    updateSelectedDisplay();
    timezoneSelect.addEventListener('focus', restoreFullLabels);
    timezoneSelect.addEventListener('blur', updateSelectedDisplay);
    timezoneSelect.addEventListener('change', (e) => {
        if (onChangeCallback)
            onChangeCallback(e.target.value);
        updateSelectedDisplay();
    });
}
export function disableTimezoneSelection(timezoneSelect, wrapper) {
    if (!timezoneSelect)
        return;
    try {
        timezoneSelect.disabled = true;
        timezoneSelect.setAttribute('aria-disabled', 'true');
        timezoneSelect.tabIndex = -1;
    }
    catch (_) { }
    if (wrapper) {
        const trigger = wrapper.querySelector('.timezone-trigger');
        const menu = wrapper.querySelector('.timezone-menu');
        if (menu) {
            menu.hidden = true;
        }
        if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.setAttribute('aria-disabled', 'true');
            trigger.tabIndex = -1;
            trigger.style.pointerEvents = 'none';
        }
        wrapper.classList.add('timezone-disabled');
    }
}
export function enableTimezoneSelection(timezoneSelect, wrapper) {
    if (!timezoneSelect)
        return;
    try {
        timezoneSelect.disabled = false;
        timezoneSelect.removeAttribute('aria-disabled');
        timezoneSelect.tabIndex = 0;
    }
    catch (_) { }
    if (wrapper) {
        const trigger = wrapper.querySelector('.timezone-trigger');
        if (trigger) {
            trigger.removeAttribute('aria-disabled');
            trigger.tabIndex = 0;
            trigger.style.pointerEvents = '';
        }
        wrapper.classList.remove('timezone-disabled');
    }
}
